import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import "../../styles/productFilters-styles.scss"
import AddFilterCriteriaView from './Includes/AddFilterCriteriaView'
import FeatherIcon from 'feather-icons-react';
import AddProductTypesView from './Includes/AddProductTypesView'
import { getProductFilters, updateProductFilters } from 'utlis/Apis/ProductFilters_API'
import { toast } from 'react-toastify'
import { ERROR_WHILE_FETCHING_PRODUCTFILTERS } from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE_UPDATING_PRODUCTFILTERS } from 'utlis/AppMessages/AppMessages'
import LoadingSkeleton from './LoadingSkeleton';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'


function AddFilterCriteria(props) {
    // props
    const { authState } = props

    const [productFilters, setProductFilters] = useState([])
    const [loading, setLoading] = useState(false)

    // store url
    const [storeUrl] = useStoreUrl()

    useEffect(() => {
        setLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getProductFilters(headers).then(res => {
            setLoading(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setProductFilters(resData.data)
            }

            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_PRODUCTFILTERS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                }
            })
        })

    }, [authState])


    const updateProductFilters_ = (productFilters_) => {
        console.log("pp", productFilters_)
        setProductFilters(arr => [...productFilters])
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        updateProductFilters(headers, { filterlist: productFilters_ }).then(res => {
            const resData = res.data
            if (resData && resData.error) {
                toast.dismiss(
                    setLoading(true),
                );
                toast.error(ERROR_WHILE_UPDATING_PRODUCTFILTERS, {
                    autoClose: 3000,
                    onClose: () => {
                        setLoading(false)
                    }
                })
            }
        })

    }

    return (
        <section id="app-product-filters" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-product-filters">
                    <div className="app-header-wrapper mb-3">
                        <div className="back-button-wrapper mb-2">
                            <Link to={storeUrl + "/settings/product-filters"} className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                                <FeatherIcon
                                    icon="arrow-left"
                                    size="14"
                                    className="icon me-1" />
                                <span>Back</span>
                            </Link>
                        </div>
                        <p className="app-heading text-capitalize">Adding new filter</p>
                    </div>
                    <Row className="product-filter-left-content">
                        <Col lg={12}>
                            <p className="product-filter-subheading">Pick the criteria you want to add</p>
                        </Col>
                        <Col lg={9} className="product-filter-right-content">
                            {loading ? <LoadingSkeleton
                                productFilters={productFilters}
                            /> :
                                productFilters.filter(e => e.default === "0").map((e, index) =>
                                    <AddFilterCriteriaView item={e}
                                        key={index}
                                        updateProductFilters={updateProductFilters_}
                                        productFilters={productFilters}
                                    />)
                            }
                        </Col>
                    </Row>
                    {!loading && productFilters.filter(e => e.default === "0").length === 0 && <Row className="product-filter-left-content">
                        <Col lg={3}>
                            <p className="product-filter-subheading">How-to</p>
                            <p className="product-filter-desc">
                                Follow the guide to add a new filter in 3 simple steps.
                            </p>
                        </Col>
                        <Col lg={9} className="product-filter-right-content">
                            <AddProductTypesView />
                        </Col>
                    </Row>}
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(AddFilterCriteria)